module.exports = __webpack_public_path__ + "static/media/QRCodeIcon.4b3ecf82.png";